import * as Yup from 'yup';

export const updateUserValidationScheme = Yup.object({
  password: Yup.string().required('This field is required'),
});
